export default "__VITE_ASSET__CVaKiZ8e__"